import { t } from '../i18n.js';
import { getPods, getPodImage } from '../pods.js';
//import { loadHtml } from '../fetch.js'
//import { NavRow } from './nav-row.js';
//import { AvatarPicker } from './avatar-picker.js';

   class UserProfile extends HTMLElement {

     // ── A. Shadow DOM + state ────────────────────────────────────────────
     constructor() {
       super();
       this._shadow         = this.attachShadow({ mode: "open" });
       this._profile        = null;
       this._drankIdx       = 0;   // index into _PODS for drank icon
       this._offeredIdx     = 2;   // index into _PODS for offered icon
       this._markedIdx      = 1;   // index into _PODS for marked icon
       this._theme          = "auto"; // "light" | "auto" | "dark"
       this._avatarDataUrl  = null;
       this._submit         = false;
       this._submitLabel    = t("save-preferences");
       this._cancel         = false;
       this._cancelLabel    = t("cancel-preferences");
       this._links          = [];
      this._version         = "x.y.z";

      this._PODS = getPods();
    }

    // ── B. Lifecycle ─────────────────────────────────────────────────────
    connectedCallback() {
      this._render();
      this._bindEvents();
    }

    // ── C. data property ─────────────────────────────────────────────────
    // Accepts { first_name, last_name, email, office, avatar,
    //           coffee_icon_drank, coffee_icon_offered,
    //           theme, push, check_updates }
    set data(obj) {
      this._profile = obj || {};

      const di = this._PODS.findIndex(e => e.id === obj?.coffee_icon_drank);
      this._drankIdx = di >= 0 ? di : 0;

      const oi = this._PODS.findIndex(e => e.id === obj?.coffee_icon_offered);
      this._offeredIdx = oi >= 0 ? oi : 2;

      const mi = this._PODS.findIndex(e => e.id === obj?.coffee_icon_marked);
      this._markedIdx = mi >= 0 ? mi : 2;

      this._theme = ["light","auto","dark"].includes(obj?.theme) ? obj.theme : "auto";
      this._avatarDataUrl = obj.avatar;

      this._links = obj.links;

      this._version = obj.version;

      this._submit         = obj?.submit ? obj.submit : false;
      this._cancel         = obj?.cancel ? obj.cancel : false;

      this._render();
      this._bindEvents();

      customElements.whenDefined("avatar-picker").then(() => {

      // Seed av1 with a remote avatar (will be treated just like base64)
      this._shadow.getElementById("av1").src = obj.avatar;

      this._shadow.getElementById("av1").removeEventListener("avatar-change", this._imageHandler);
      this._shadow.getElementById("av1").addEventListener("avatar-change", this._imageHandler);
      
    });
    }

    // ── D. submitLabel property ───────────────────────────────────────────
    set submitLabel(label) {
      this._submitLabel = label || t("save-preferences");
      const btn = this._shadow.getElementById("save-btn");
      if (btn) btn.textContent = this._submitLabel;
    }

    // ── E. Attribute bridge ───────────────────────────────────────────────
    static get observedAttributes() { return ["data", "submit-label"]; }
    attributeChangedCallback(name, _, newVal) {
      if (name === "data")         { try { this.data = JSON.parse(newVal); } catch {} }
      if (name === "submit-label") { this.submitLabel = newVal; }
    }

    // ── F. Small helpers ──────────────────────────────────────────────────
    _initials() {
      const p = this._profile || {};
      return ((p.first_name?.[0] || "") + (p.last_name?.[0] || "")).toUpperCase() || "?";
    }

    _imageHandler(e) {
      // Listen for avatar-change on any picker
      let me = document.getElementById("user-profile");
      
      console.log("avatar-change fired by:", e.target.id);
      console.log("  base64 length :", e.detail.base64.length);
      console.log("  mimeType      :", e.detail.mimeType);
      console.log("  width         :", e.detail.width);
      console.log("  height        :", e.detail.height);
      console.log("  image         :", e.detail.base64);

      me._avatarDataUrl  = e.detail.base64;
    }

    _lockIcon() {
      return `<span class="lock-icon">
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
          <rect x="2" y="5" width="8" height="6" rx="1.5" stroke="currentColor" stroke-width="1.1"/>
          <path d="M4 5V3.5a2 2 0 014 0V5" stroke="currentColor" stroke-width="1.1"/>
        </svg></span>`;
    }

    _toggleHTML(id, checked) {
      return `<label class="toggle" aria-label="${id}">
        <input type="checkbox" id="${id}" ${checked ? "checked" : ""} />
        <div class="toggle-track"></div>
        <div class="toggle-thumb"></div>
      </label>`;
    }

    // ── G. Emoji grid HTML ────────────────────────────────────────────────
    // gridId distinguishes "drank" vs "offered" grids so clicks stay isolated
    _emojiGridHTML(gridId, selectedIdx) {
      return this._PODS.map((e, i) => `
        <button class="emoji-btn${i === selectedIdx ? " selected" : ""}"
                data-idx="${i}" data-grid="${gridId}" aria-label="${e.label}">
          <span class="emoji-glyph"><img class="emoji-image" src="${e.image}"></span>
          <span class="emoji-label">${e.label}</span>
        </button>`).join("");
    }

    // ── H. Theme segmented control HTML ───────────────────────────────────
    _themeSegHTML() {
      const modes = [
        { key: "light", label: t("light"),
          icon: `<svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="3" stroke="currentColor" stroke-width="1.3"/>
            <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41"
                  stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
          </svg>` },
        { key: "auto", label: t("auto"),
          icon: `<svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M8 2a6 6 0 100 12A6 6 0 008 2z" stroke="currentColor" stroke-width="1.3"/>
            <path d="M8 2v12" stroke="currentColor" stroke-width="1.3"/>
            <path d="M8 2a6 6 0 010 12" fill="currentColor" opacity="0.2"/>
          </svg>` },
        { key: "dark", label: t("dark"),
          icon: `<svg fill="#000000" width="14" height="14" viewBox="0 0 36 36" version="1.1"  preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
           <title>moon-line</title>
           <path d="M31,27.19a1,1,0,0,0-1-.56c-.28,0-.56,0-.85,0A11,11,0,0,1,24.92,5.61a1,1,0,0,0,.61-1,1,1,0,0,0-.67-.91,14.7,14.7,0,0,0-5-.87,15.12,15.12,0,0,0,0,30.24,14.78,14.78,0,0,0,11-4.81A1,1,0,0,0,31,27.19ZM19.89,31.12a13.12,13.12,0,0,1,0-26.24,11.81,11.81,0,0,1,2,.16,13,13,0,0,0,5.72,23.53A12.75,12.75,0,0,1,19.89,31.12Z" class="clr-i-outline clr-i-outline-path-1"></path>
           <rect x="0" y="0" width="36" height="36" fill-opacity="0"/>
           </svg>` },
      ];
      return modes.map(m => `
        <button class="theme-btn${m.key === this._theme ? " active" : ""}"
                data-theme="${m.key}">
          ${m.icon} ${m.label}
        </button>`).join("");
    }

    // ── K. Collect + fire save event ─────────────────────────────────────
    _handleSave() {
      const detail = {
        coffee_icon_drank:   this._PODS[this._drankIdx].id,
        coffee_icon_offered: this._PODS[this._offeredIdx].id,
        coffee_icon_marked: this._PODS[this._markedIdx].id,
        theme:         this._theme,
        push:          this._shadow.getElementById("pref-push")?.checked    ?? true,
        check_updates: this._shadow.getElementById("pref-updates")?.checked ?? true,
      };
      if (this._avatarDataUrl) detail.avatar = this._avatarDataUrl;

      this.dispatchEvent(new CustomEvent("profile-save", {
        detail, bubbles: true, composed: true
      }));

      const toast = this._shadow.getElementById("toast");
      if (toast) {
        toast.classList.add("visible");
        setTimeout(() => toast.classList.remove("visible"), 3000);
      }
    }

    _handleCancel() {
      const detail = {
        coffee_icon_drank:   this._PODS[this._drankIdx].id,
        coffee_icon_offered: this._PODS[this._offeredIdx].id,
        coffee_icon_marked: this._PODS[this._markedIdx].id,
        theme:         this._theme,
        push:          this._shadow.getElementById("pref-push")?.checked    ?? true,
        check_updates: this._shadow.getElementById("pref-updates")?.checked ?? true,
      };
      if (this._avatarDataUrl) detail.avatar = this._avatarDataUrl;

      this.dispatchEvent(new CustomEvent("profile-cancel", {
        detail, bubbles: true, composed: true
      }));
    }

    _handleClean() {
      this.dispatchEvent(new CustomEvent("clean-cache", {
        detail: { cache: true, localStorage: true, userStats: true, adminStats: true }, bubbles: true, composed: true
      }));
    }


    _handleReleaseNotes() {
      this.dispatchEvent(new CustomEvent("open-release-note", {
        detail: { ver: this._version }, bubbles: true, composed: true
      }));
    }

    // ── L1. Show/hide push notification warning ───────────────────────────
    _showPushWarning(show, message) {
      const root = this._shadow;
      const existingWarning = root.getElementById("push-warning");
      
      if (!show) {
        // Remove warning if exists
        if (existingWarning) {
          existingWarning.remove();
        }
        return;
      }
      
      // Don't add duplicate warning
      if (existingWarning) {
        existingWarning.textContent = message || t("unable-notifications");
        return;
      }
      
      // Create warning element
      const warning = document.createElement("span");
      warning.id = "push-warning";
      warning.style.cssText = "font-size: 11px; color: #e53e3e; margin-left: 8px; animation: fadeIn 0.3s ease-in;";
      warning.textContent = message || t("unable-notifications");
      
      // Find the push notification row and append warning
      const pushRow = root.querySelector('.row:has(#pref-push)');
      if (pushRow) {
        const rowLeft = pushRow.querySelector('.row-left');
        if (rowLeft) {
          rowLeft.appendChild(warning);
        }
      }
    }
    

    // ── L. Bind all events ────────────────────────────────────────────────
    _bindEvents() {
      const root = this._shadow;

      // Updates check - fire immediate event for check updates
      const updatesToggle = root.getElementById("pref-updates");
      if (updatesToggle) {
        updatesToggle.addEventListener("click", (e) => {
          const isChecked = e.target.checked;
          
          // Fire immediate event for push notification permission request
          this.dispatchEvent(new CustomEvent("profile-updates-toggle", {
            detail: { 
              enabled: isChecked,
              toggleElement: e.target
            },
            bubbles: true,
            composed: true
          }));
        });
      }

      // Push notification toggle - fire immediate event for permission request
      const pushToggle = root.getElementById("pref-push");
      if (pushToggle) {
        pushToggle.addEventListener("click", (e) => {
          const isChecked = e.target.checked;
          
          // Fire immediate event for push notification permission request
          this.dispatchEvent(new CustomEvent("profile-push-toggle", {
            detail: { 
              enabled: isChecked,
              toggleElement: e.target
            },
            bubbles: true,
            composed: true
          }));
        });
      }

      // Listen for push success/error events to show/hide warnings
      this.addEventListener("profile-push-success", () => {
        this._showPushWarning(false);
      });

      this.addEventListener("profile-push-error", (e) => {
        this._showPushWarning(true, e.detail?.message);
      });

      // Emoji grids — delegate from each grid container
      root.getElementById("grid-drank")?.addEventListener("click", e => {
        const btn = e.target.closest(".emoji-btn");
        if (!btn) return;
        this._drankIdx = Number(btn.dataset.idx);
        root.querySelectorAll("#grid-drank .emoji-btn").forEach((b, i) =>
          b.classList.toggle("selected", i === this._drankIdx));
        const preview = root.getElementById("preview-drank-image");
        if (preview) preview.src = this._PODS[this._drankIdx].image;

        // Dispatch immediate color change event for the main app to handle
        this.dispatchEvent(new CustomEvent("profile-color-change", {
          detail: { 
            coffee_icon_drank:   this._PODS[this._drankIdx].id,
            coffee_icon_offered: this._PODS[this._offeredIdx].id,
            coffee_icon_marked: this._PODS[this._markedIdx].id,
           },
          bubbles: true,
          composed: true
        }));
      });

      root.getElementById("grid-offered")?.addEventListener("click", e => {
        const btn = e.target.closest(".emoji-btn");
        if (!btn) return;
        this._offeredIdx = Number(btn.dataset.idx);
        root.querySelectorAll("#grid-offered .emoji-btn").forEach((b, i) =>
          b.classList.toggle("selected", i === this._offeredIdx));
        const preview = root.getElementById("preview-offered-image");
        if (preview) preview.src = this._PODS[this._offeredIdx].image;

        // Dispatch immediate color change event for the main app to handle
        this.dispatchEvent(new CustomEvent("profile-color-change", {
          detail: { 
            coffee_icon_drank:   this._PODS[this._drankIdx].id,
            coffee_icon_offered: this._PODS[this._offeredIdx].id,
            coffee_icon_marked: this._PODS[this._markedIdx].id,
           },
          bubbles: true,
          composed: true
        }));
      });

      root.getElementById("grid-marked")?.addEventListener("click", e => {
        const btn = e.target.closest(".emoji-btn");
        if (!btn) return;
        this._markedIdx = Number(btn.dataset.idx);
        root.querySelectorAll("#grid-marked .emoji-btn").forEach((b, i) =>
          b.classList.toggle("selected", i === this._markedIdx));
        const preview = root.getElementById("preview-marked-image");
        if (preview) preview.src = this._PODS[this._markedIdx].image;

        // Dispatch immediate color change event for the main app to handle
        this.dispatchEvent(new CustomEvent("profile-color-change", {
          detail: { 
            coffee_icon_drank:   this._PODS[this._drankIdx].id,
            coffee_icon_offered: this._PODS[this._offeredIdx].id,
            coffee_icon_marked: this._PODS[this._markedIdx].id,
           },
          bubbles: true,
          composed: true
        }));
      });

      // Theme segmented control
      root.getElementById("theme-seg")?.addEventListener("click", e => {
        const btn = e.target.closest(".theme-btn");
        if (!btn) return;
        this._theme = btn.dataset.theme;
        root.querySelectorAll(".theme-btn").forEach(b =>
          b.classList.toggle("active", b.dataset.theme === this._theme));
        
        // Dispatch immediate theme change event for the main app to handle
        this.dispatchEvent(new CustomEvent("profile-theme-change", {
          detail: { theme: this._theme },
          bubbles: true,
          composed: true
        }));
      });

      // Save
      root.getElementById("save-btn")?.addEventListener("click", () => this._handleSave());
      root.getElementById("cancel-btn")?.addEventListener("click", () => this._handleCancel());
      root.getElementById("clean-btn")?.addEventListener("click", () => this._handleClean());
      const rowVersion = root.getElementById("rowVersion");
      rowVersion.action = () => {
        this._handleReleaseNotes();
        
      }

    }

    // ── M. Full render ────────────────────────────────────────────────────
    _render() {
      const p       = this._profile || {};
      const src     = this._avatarDataUrl || "";
      const ini     = this._initials();
      const push    = p.push          !== false;
      const updates = p.check_updates !== false;

      let submitBar = "";
      if (this._submit) {
        submitBar = `
          <div class="save-bar">
            <button class="save-btn" id="save-btn">${this._submitLabel}</button>
            <div class="toast" id="toast">
              <span class="toast-dot"></span>
              ${t("preferences-saved")}
            </div>
          </div>`;
      }

      let cancelBar = "";
      if (this._cancel) {
        cancelBar = `
          <div class="cancel-bar">
            <button class="cancel-btn" id="cancel-btn">${this._cancelLabel}</button>
            <div class="toast" id="toast">
              <span class="toast-dot"></span>
              ${t("preferences-cancel")}
            </div>
          </div>`;
      }

      this._shadow.innerHTML = `
        <style>
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
          :host { display: block; }

          .wrap { 
            /* max-width: 700px; */
            display: flex; 
            flex-direction: column; 
            gap: 12px; 
          }

          .card { 
            background: #fff; 
            border: 0.5px solid #e0dfd7; 
            border-radius: 12px; 
            overflow: hidden; 
          }

          /* ── Hero ── */
          .hero {
            background: #5D4037;
            padding: 1.5rem 1.25rem 1rem;
            display: flex; align-items: center; gap: 16px;
            justify-content: space-between;
            border-bottom: 0.5px solid #e0dfd7;
          }

          .avatar-wrap { position: relative; flex-shrink: 0; }

          .identity { min-width: 0; text-align: right; }
          .identity-name  { font-size: 17px; font-weight: 600; color: #ffffff; margin-bottom: 2px; }
          .identity-email { font-size: 12px; color: #c9c9c9; margin-bottom: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
          .alias-pill {
            display: inline-flex; align-items: center; gap: 4px;
            font-size: 11px; font-weight: 300;
            padding: 3px 8px; border-radius: 99px;
            background: #F5EDEB; color: #A28077;
          }

          /* ── Shared layout ── */
          .section-title {
            font-size: 14px; font-weight: 800; color: #000000;
            letter-spacing: 0.06em; text-transform: uppercase;
            padding: 12px 16px 6px;
            margin-top: 10px;
          }

          .row {
            display: flex; align-items: center; justify-content: space-between;
            padding: 12px 16px; gap: 12px;
            border-top: 0.5px solid #e0dfd7;
          }

          .row-left { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1; }
          .row-btn {
            background: transparent; 
            color: #fff; 
            border: none;
            cursor: pointer;
            touch-action: manipulation;
            padding-inline: 0px;
            padding-block: 0px;
          }
          .row-label { font-size: 14px; font-weight: 500; color: #1a1a1a; }
          .row-sub   { font-size: 11px; color: #aaa; }

          .readonly-val {
            font-size: 13px; color: #888;
            text-align: right; flex-shrink: 0;
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 55%;
          }

          .lock-icon { display: inline-flex; align-items: center; vertical-align: middle; margin-left: 3px; opacity: 0.35; }

          /* ── Toggle ── */
          .toggle { position: relative; width: 44px; height: 26px; flex-shrink: 0; cursor: pointer; }
          .toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
          .toggle-track { position: absolute; inset: 0; border-radius: 99px; background: #d0cfc7; transition: background 0.2s; }
          .toggle input:checked + .toggle-track { background: #5D4037; }
          .toggle-thumb { position: absolute; top: 3px; left: 3px; width: 20px; height: 20px; border-radius: 50%; background: #fff; transition: transform 0.2s; pointer-events: none; }
          .toggle input:checked ~ .toggle-thumb { transform: translateX(18px); }

          /* ── Coffee icon pickers ── */
          .picker-header {
            display: flex; align-items: center; justify-content: space-between;
            padding: 12px 16px 0;
            border-top: 0.5px solid #e0dfd7;
          }
          .picker-title   { font-size: 14px; font-weight: 500; color: #1a1a1a; }
          .picker-preview { font-size: 24px; line-height: 1; }
          .picker-image   { width: 25px; heigth: 25px;}
          .picker-hint    { font-size: 11px; color: #aaa; padding: 3px 16px 6px; }

          .emoji-grid {
            display: grid;
            grid-template-columns: repeat(5, minmax(0,1fr));
            gap: 6px;
            padding: 6px 16px 14px;
          }
          
          .emoji-image {
            width: 40px;
            heigth: 40px;
          }

          .emoji-btn {
            display: flex; flex-direction: column; align-items: center; gap: 4px;
            padding: 2px 4px 2px;
            border-radius: 8px; border: 1.5px solid #e0dfd7;
            background: #fff; cursor: pointer;
            transition: border-color 0.15s, background 0.15s;
          }
          .emoji-btn:hover { background: #f7f6f2; }
          .emoji-btn.selected { border-color: #1D9E75; background: #E1F5EE; }

          .emoji-glyph { font-size: 20px; line-height: 0; }
          .emoji-label { font-size: 10px; color: #aaa; text-align: center; }
          .emoji-btn.selected .emoji-label { color: #0F6E56; }

          .picker-divider { height: 0.5px; background: #e0dfd7; margin: 0 16px; }

          /* ── Theme segmented control ── */
          .theme-row {
            display: flex; align-items: center; justify-content: space-between;
            padding: 12px 16px; gap: 12px;
            border-top: 0.5px solid #e0dfd7;
          }

          .theme-seg {
            display: flex;
            background: #f5f5f3;
            border-radius: 8px;
            padding: 3px;
            gap: 2px;
            flex-shrink: 0;
          }

          .theme-btn {
            display: flex; 
            align-items: center; 
            gap: 3px;
            font: inherit; 
            font-size: 12px; 
            font-weight: 300;
            padding: 5px 10px;
            border-radius: 6px; 
            border: none;
            background: 
            transparent; 
            color: #888;
            cursor: pointer;
            transition: 
            background 0.12s, color 0.12s;
            white-space: nowrap;
          }

          .theme-btn.active {
            background: #fff; color: #1a1a1a;
            border: 0.5px solid #e0dfd7;
          }

          .theme-btn svg { margin: 2px; width: 14px; height: 14px; flex-shrink: 0; }

          /* ── Save bar ── */
          .save-bar, .cancel-bar { padding: 12px 16px; border-top: 0.5px solid #e0dfd7; }

          .save-btn, .cancel-btn {
            width: 100%; 
            padding: 10px 16px;
            font: inherit; 
            font-size: 14px; 
            font-weight: 300;
            border-radius: 8px;
            background: #5D4037; 
            color: #fff; 
            border: none;
            cursor: pointer;
            transition: opacity 0.15s, transform 0.1s;
            touch-action: manipulation;
          }
          .save-btn:hover, .cancel-btn:hover  { opacity: 0.85; }
          .save-btn:active, .cancel-btn:active { transform: scale(0.98); }

          .action-btn {
            padding-bottom: 10px;
            font: inherit; 
            font-size: 14px; 
            font-weight: 300;
            border-radius: 8px;
            background: transparent; 
            color: #fff; 
            border: none;
            cursor: pointer;
            transition: opacity 0.15s, transform 0.1s;
            touch-action: manipulation;
          }

          .nr-arrow {
            color: #aaa;
            flex-shrink: 0;
            transition: transform 0.15s;
          }
          .nr-inner:hover { 
            transform: translateX(2px); 
            background: #f5f5f3;
          }

          .version-btn-x {
            padding: 10px 16px;
            font: inherit; 
            font-size: 14px; 
            font-weight: 300;
            border-radius: 8px;
            border: none;
            cursor: pointer;
            transition: opacity 0.15s, transform 0.1s;
            touch-action: manipulation;
            /*display: inline-flex; */
            align-items: center; 
            gap: 4px;
            font-size: 11px; font-weight: 300;
            padding: 3px 8px; border-radius: 99px;
            /*background: #5D4037; */
            color: #ffffff;
            min-height: 26px;
            min-width: 44px;
          }

          .version-btn {
            background-color: transparent;
            color: #aaa;
            border-width: 0px;
          }

          .toast {
            display: none; align-items: center; gap: 8px;
            font-size: 12px; color: #0F6E56;
            background: #E1F5EE; border: 0.5px solid #5DCAA5;
            border-radius: 8px; padding: 8px 12px; margin-top: 10px;
          }
          .toast.visible { display: flex; }
          .toast-dot { width: 6px; height: 6px; border-radius: 50%; background: #1D9E75; flex-shrink: 0; }

          /* ── Footer ── */
          .footer-header {
            display: flex; 
            align-items: center; 
            justify-content: center;
          }
          .footer-title   { font-size: 13px; font-weight: 300; color: #1a1a1a; margin-right: 10px;}
          .footer-actions { font-size: 24px; line-height: 1; margin-left: 10px;}

          .overlay {
            dispay: none;
          }
        
          .panel {
   
            transition: transform 3s ease;
          }

          .panel.active {
            transform: translateX(0); /* slides in */
          }

          .panel.hide {
            transform: translateX(-110%); /* slides out left */
          }

          @media (max-width: 400px) {
            .hero { padding: 1.25rem 1rem 0.875rem; }
            .card { border-left: none; border-right: none; }
            .emoji-grid { gap: 5px; padding: 4px 16px 6px; }
            .theme-btn { padding: 5px 8px; font-size: 11px; }
          }

          /*
          @media (prefers-color-scheme: dark) {
            .card             { background: #1e1e1c; border-color: #333330; }
            .hero             { background: #2a2a28; border-bottom-color: #333330; }
            .identity-name    { color: #f0ede8; }
            .identity-email   { color: #666; }
            .section-title    { color: #666; }
            .row              { border-top-color: #333330; }
            .theme-row        { border-top-color: #333330; }
            .row-label        { color: #f0ede8; }
            .row-sub          { color: #555; }
            .readonly-val     { color: #666; }
            .picker-title     { color: #f0ede8; }
            .picker-hint      { color: #555; }
            .picker-divider   { background: #333330; }
            .emoji-btn        { background: #1e1e1c; border-color: #333330; }
            .emoji-btn:hover  { background: #2a2a28; }
            .emoji-btn.selected { background: #085041; border-color: #1D9E75; }
            .emoji-label      { color: #666; }
            .theme-seg        { background: #2a2a28; }
            .theme-btn        { color: #888; }
            .theme-btn.active { background: #1e1e1c; color: #f0ede8; border-color: #333330; }
            .save-bar         { border-top-color: #333330; }
            .toggle-track     { background: #444441; }
          }
          */
        </style>

        <div id="wrap" class="wrap panel">

          <!-- Identity card -->
          <div class="card">
            <div class="hero">
              <div class="avatar-wrap">
                <avatar-picker id="av1" size="72" initials="KA"></avatar-picker>
              </div>
              <div class="identity">
                <p class="identity-name">${p.first_name || ""} ${p.last_name || ""}</p>
                <p class="identity-email">${p.email || ""}</p>
                <span class="alias-pill">
                  @${p.alias || ""}
                </span>
              </div>
            </div>

            <div class="section-title">${t("account-info")}</div>
            <div class="row">
              <div class="row-left"><span class="row-label">${t("first-name")}</span></div>
              <span class="readonly-val">${p.first_name || "—"} ${this._lockIcon()}</span>
            </div>
            <div class="row">
              <div class="row-left"><span class="row-label">${t("last-name")}</span></div>
              <span class="readonly-val">${p.last_name || "—"} ${this._lockIcon()}</span>
            </div>
            <div class="row">
              <div class="row-left"><span class="row-label">${t("email")}</span></div>
              <span class="readonly-val" style="font-size:12px">${p.email || "—"} ${this._lockIcon()}</span>
            </div>
            <div class="row">
              <div class="row-left"><span class="row-label">${t("office")}</span></div>
              <span class="readonly-val">${p.office || "—"} ${this._lockIcon()}</span>
            </div>


           <!-- Preferences card -->
         
            <div class="section-title">${t("preferences")}</div>

            <div class="theme-row">
              <div class="row-left">
                <span class="row-label">${t("appearance")}</span>
                <span class="row-sub">${t("app-colour-scheme")}</span>
              </div>
              <div class="theme-seg" id="theme-seg">
                ${this._themeSegHTML()}
              </div>
            </div>

            <div class="row">
              <div class="row-left">
                <span class="row-label">${t("push-notifications")}</span>
                <span class="row-sub">${t("get-alerts")}</span>
              </div>
              ${this._toggleHTML("pref-push", push)}
            </div>

            <div class="row">
              <div class="row-left">
                <span class="row-label">${t("check-updates")}</span>
                <span class="row-sub">${t("notify-updates")}</span>
              </div>
              ${this._toggleHTML("pref-updates", updates)}
            </div>

            <div class="picker-header">
              <span class="picker-title">${t("drank-icon")}</span>
              <span class="picker-preview" id="preview-drank"><img id="preview-drank-image" class="picker-image" src="${this._PODS[this._drankIdx].image}"></span>
            </div>
            <!--<p class="picker-hint">Shown next to coffees you consumed</p>-->
            <div class="emoji-grid" id="grid-drank">
              ${this._emojiGridHTML("drank", this._drankIdx)}
            </div>


            <div class="picker-header" style="margin-top:10px">
              <span class="picker-title">${t("offered-icon")}</span>
              <span class="picker-preview" id="preview-offered"><img id="preview-offered-image" class="picker-image" src="${this._PODS[this._offeredIdx].image}"></span>
            </div>
            <!--<p class="picker-hint">Shown next to coffees you offered to others</p>-->
            <div class="emoji-grid" id="grid-offered">
              ${this._emojiGridHTML("offered", this._offeredIdx)}
            </div>

            

            <div class="picker-header" style="margin-top:10px">
              <span class="picker-title">${t("marked-icon")}</span>
              <span class="picker-preview" id="preview-marked"><img id="preview-marked-image" class="picker-image" src="${this._PODS[this._markedIdx].image}"></span>
            </div>
            <!--<p class="picker-hint">Shown next to coffees you keep track of</p>-->
            <div class="emoji-grid" id="grid-marked">
              ${this._emojiGridHTML("marked", this._markedIdx)}
            </div>

             <!-- About & Maintenance card -->
             <div class="section-title">${t("about")}</div>
             
             <nav-row
              id="rowVersion"
              label="${t("app-version")}"
              sublabel="${t("release-notes")} (${this._version})"
              icon="star"
              title="${t("app-version")}">
            </nav-row>
            

             <nav-row
              id="rowTerms"
              label="${t("terms-of-service")}"
              sublabel="${t("terms-of-service-desc")}"
              icon="doc"
              title="${t("terms-of-service")}"
              url="./tos.html">
            </nav-row>

            <nav-row
              id="rowPrivacy"
              label="${t("privacy-policy")}"
              sublabel="${t("privacy-policy-desc")}"
              icon="shield"
              title="${t("privacy-policy")}"
              url="./pp.html">
            </nav-row>

             <nav-row
              id="rowCleanup"
              label="${t("cleanup")}"
              sublabel="${t("cleanup-desc")}"
              icon="memory"
              title="${t("cleanup")}"
              url="./cleanup.html">
            </nav-row>

            
            ${submitBar}
            ${cancelBar}
          </div>
         </div>
         <div id="overlay" class="panel">
         </div>
      `;
    }
  }

export { UserProfile }